module.exports = __webpack_public_path__ + "media/images/icons/country_flags/kg-d228cc16a65c5f9e44708d8cdf680047.svg";